module.exports = __webpack_public_path__ + "static/img/horizontalLogo02.2d3d291.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUs/horizontalLogo02.png
// module id = e0Ms
// module chunks = 1